// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AttackExploitedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AttackExploitedIcon" ref={forwardedRef} {...props}>
      <path d="M1.75 18.401h4.232c.158-.41.4-.896.72-1.5H3.317v-2.28c0-.536 1.111-1.843 3.496-1.843L4.428 8.856C4.341 8.62 4.218 8.286 4.82 7.663c.66-.684 3.001-3.19 4.125-4.396.298-.32 1.852-.367 2.182 0 .82.908 2.865 3.089 4.092 4.396.272.29.418.562.454.808.278.425.583.967.953 1.645l.563-.828a1.64 1.64 0 0 0 .296-.938 1.64 1.64 0 0 0-.295-.94l-5.37-5.466A3.8 3.8 0 0 0 10.04 1.5a3.8 3.8 0 0 0-1.782.443L2.88 7.41a1.87 1.87 0 0 0-.254.94A1.87 1.87 0 0 0 2.88 9.288l1.746 2.616C3.784 12.002 3.186 12.399 2.624 13a3.2 3.2 0 0 0-.874 2.183z" />
      <path d="M13.64 6.25v.846a2.5 2.5 0 0 0-1.206.235 1.7 1.7 0 0 0-.345.222 13 13 0 0 0-4.18.011L7.911 9.56a2.1 2.1 0 0 0 .125.743 2 2 0 0 0 .374.634 1.75 1.75 0 0 0 .566.425 1.6 1.6 0 0 0 .64.152L8.866 12.9a2.8 2.8 0 0 1-.628-.206 3 3 0 0 1-.96-.723 3.3 3.3 0 0 1-.635-1.074 3.6 3.6 0 0 1-.212-1.262L6.43 6.25a22 22 0 0 1 7.211 0" />
      <path d="M14 12.943h-1v2.5h1z" />
      <path d="M13.5 16.181a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25" />
      <path d="M13.074 8.696c-.297.14-.522.555-.972 1.386l-3.83 7.072c-.415.765-.622 1.148-.587 1.46a1 1 0 0 0 .421.707C8.364 19.5 8.8 19.5 9.67 19.5h7.66c.87 0 1.306 0 1.564-.18a1 1 0 0 0 .42-.707c.036-.312-.171-.695-.585-1.46l-3.83-7.072c-.45-.83-.676-1.246-.973-1.386a1 1 0 0 0-.852 0M9.519 18l3.981-7.35L17.482 18zm8.321.717-.003-.008.002.005z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AttackExploitedIcon = /* @__PURE__ */ Object.assign(
  AttackExploitedIconComponent,
  { displayName: 'AttackExploitedIcon' },
);
